import CryptoJS from 'crypto-js';

export const encryptTextByAES = (text: any) => {
	try {
		const password = localStorage.getItem('UUID');
		if (!password) {
			return text;
		}
		const key = CryptoJS.enc.Utf8.parse(password);
		const encrypted = CryptoJS.AES.encrypt(text, key, {
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7,
		});
		const encryptedText = encrypted.toString();
		return encryptedText;
	} catch (error) {
		return text;
	}
};

export const decryptTextByAES = (text: any) => {
	try {
		const password = localStorage.getItem('UUID');
		if (!password) {
			return text;
		}
		const key = CryptoJS.enc.Utf8.parse(password);
		const decrypted = CryptoJS.AES.decrypt(text, key, {
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7,
		});
		const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
		return decryptedText;
	} catch (err) {
		return text;
	}
};
